import PropTypes from 'prop-types';
import { Box, IconButton, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next';
import ProfileSection from './ProfileSection';
import ClinicAccessSelector from './ClinicAccessSelector';
import NameHeader from './nameHeader';

function Header({
    handleLeftDrawerToggle,
    open = false,
    desktop = true,
    hasSidebar = true
}) {
    const { t } = useTranslation('navigation', { useSuspense: false });
    const label = open
        ? t('close', { defaultValue: 'Recolher menu lateral' })
        : t('open', { defaultValue: 'Abrir menu lateral' });
    return (
        <>
            {!desktop && hasSidebar && (
                <Tooltip title={label}>
                    <IconButton
                        edge="start"
                        color="primary"
                        onClick={handleLeftDrawerToggle}
                        aria-label={label}
                        aria-controls="medical-sidebar"
                        aria-expanded={open}
                        sx={{ mt: 2, flexShrink: 0 }}
                    >
                        <MenuIcon />
                    </IconButton>
                </Tooltip>
            )}
            <NameHeader />
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: 0,
                    flexShrink: 1,
                    maxWidth: { xs: 'min(42vw, 150px)', sm: 240, lg: 320 },
                    '& > .MuiButton-root': { maxWidth: '100%', mr: 0 }
                }}
            >
                <ClinicAccessSelector />
            </Box>
            <ProfileSection />
        </>
    );
}
Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func,
    open: PropTypes.bool,
    desktop: PropTypes.bool,
    hasSidebar: PropTypes.bool
};
export default Header;
